import { useEffect } from 'react'

import { SOCKET_CHANNELS, EVENT_ACTIONS, EVENT_STATUSES } from '@/constants'
import { useNeatSocket } from '@/components/Providers/NeatSocketProvider'
import { handleRedirectToAuth } from '@/hooks/useAuth'

const useUserDeletedListener = () => {
  const { socket, isConnected } = useNeatSocket()
  const handleListener = ({ action, status }) => {
    if (action === EVENT_ACTIONS.USER_DELETED && status === EVENT_STATUSES.SUCCESS) {
      handleRedirectToAuth()
    }
  }

  useEffect(() => {
    if (socket && isConnected) socket.on(SOCKET_CHANNELS.staypuft, handleListener)
    return () => socket?.off(SOCKET_CHANNELS.staypuft, handleListener)
  }, [socket, isConnected])
}

export default useUserDeletedListener
